import { render, staticRenderFns } from "./PhButton.vue?vue&type=template&id=ea4607d2"
import script from "./PhButton.vue?vue&type=script&lang=js"
export * from "./PhButton.vue?vue&type=script&lang=js"
import style0 from "./PhButton.vue?vue&type=style&index=0&id=ea4607d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports